import { ServerDate } from "@eres/core";

export interface OwnerCommitteeDocument {
	documentId?: number;
	arabicName: string;
	englishName: string;
	name: string;
	maxSize?: number;
	isMandatory?: boolean;
	docs: CommitteeDoc[];
	serverId?: number;
	identity?: number;
}

export interface CommitteeDoc {
	fileName?: string;
	name: string;
	fileSize?: number;
	localData?: string;
	localFile: File;
	type?: string;
	fileUrl?: string;
	identity: number;
	documentId?: number;
}

export interface OwnerCommitteeRegister {
	PropertyId: number;
	OwnerNumber: number;
	EmiratesId: string | undefined;
	requestsource: string;
	DocumentIds: number[];
	Dewanumber: string | undefined;
}

export interface BoardDocumentState {
	Documents?: OwnerCommitteeDocument[];
	errorDocs: any[];
	action?: string;
}

export interface ValidationError {
	errorNumber: number;
	errorMessage?: string;
	nameAr?: string;
	nameEn?: string;
	identity: number;
}

export interface OwnerCommitteeStatus {
	referenceId: string;
	ownerNumber: number;
	propertyId: number;
	submittedDate: string;
	registrationStatus: RegistrationStatus;
	boardMemberStatus: BoardMemberStatus;
	propertyInfo: PropertyInfo;
}

export interface RegistrationStatus {
	parentId: number;
	identity: number;
	nameAr?: string;
	nameEn?: string;
}

export interface BoardMemberStatus {
	parentId: number;
	identity: number;
	nameAr?: string;
	nameEn?: string;
}

export interface PropertyInfo {
	arabicName?: string;
	englishName?: string;
}

export interface OwnerCommitteeLookup {
	parentId: number;
	identity: number;
	nameAr?: string;
	nameEn?: string;
}

export type ServiceRate = 1 | 2 | 3 | 4 | 5;

export interface OwnerFeedbackRequest {
	id: number;
	ownerFeedback: string;
	ownerStatusId: number;
	documents: { id: number }[];
	serviceRate: ServiceRate;
}

export interface JOPServiceEntry {
	category: { identity: number };
	subCategory?: { identity: number };
	description: string;
	documents: { id: number }[];
	meetingDate?: ServerDate;
}

export interface JOPRequest {
	propertyId: number;
	ownerNumber: number;
	jopServiceTypeId: number;
	jopServiceEntry: JOPServiceEntry[];
	applicantTypeId: number;
}

export interface BaseJOPActionRequest {
	id: number;
	workflowComment: string;
	documents: { id: string }[];
}

export type CloseRequest = BaseJOPActionRequest;
export type ForwardToOCRequest = BaseJOPActionRequest;

export interface RequestTenderRequest extends BaseJOPActionRequest {
	isTechnicalTender: boolean;
	isFinancialTender: boolean;
}

export enum OwnerCommitteeStatusID {
	PENDING = 1,
	REJECTED = 2,
	RERA_DIRECTOR_APPROVAL = 3,
	RERA__APPROVAL = 4,
	REVIEW = 5,
}

export function getOwnerCommitteeStatusClass( item: OwnerCommitteeStatus ) {
	switch ( item.registrationStatus.identity ) {
		case OwnerCommitteeStatusID.PENDING:
			return "pending";

		case OwnerCommitteeStatusID.REJECTED:
			return "rejected";

		case OwnerCommitteeStatusID.RERA_DIRECTOR_APPROVAL:
			return "rera-director-approval";

		case OwnerCommitteeStatusID.RERA__APPROVAL:
			return "rera-approval";

		case OwnerCommitteeStatusID.REVIEW:
			return "review";
	}
}
